'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jsxRuntime = require('react/jsx-runtime');
var coreRenderer = require('@tempi/core-renderer');
var styled = require('@emotion/styled');
var React = require('react');
var Slider$1 = require('../../../core/DsSlider/Slider.js');
var ui = require('../../image/ui.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Slider = (props) => {
  const _a = props, { items, type, commonStyle, isEditingMode } = _a, sliderConfig = __objRest(_a, ["items", "type", "commonStyle", "isEditingMode"]);
  const { displayItems } = coreRenderer.useTimeVisibility(items, isEditingMode);
  const wrapperStyleRef = React.useRef(__spreadValues({}, commonStyle));
  const handleChangeWrapperStyle = () => {
    const newWrapperStyle = __spreadValues({}, wrapperStyleRef.current);
    delete newWrapperStyle.height;
    delete newWrapperStyle.borderRadius;
    wrapperStyleRef.current = newWrapperStyle;
  };
  if ((sliderConfig == null ? void 0 : sliderConfig.slidesPerColumn) > 1 || (sliderConfig == null ? void 0 : sliderConfig.showThumbnail)) {
    handleChangeWrapperStyle();
  }
  const sliderPerRow = (sliderConfig == null ? void 0 : sliderConfig.slidesPerColumn) || 1;
  return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
    commonStyle: wrapperStyleRef.current,
    children: /* @__PURE__ */ jsxRuntime.jsx(Slider$1.DSSlider, __spreadProps(__spreadValues(__spreadValues({
      commonStyle
    }, sliderConfig), !(sliderConfig == null ? void 0 : sliderConfig.showThumbnail) && {
      paginationStyle: 2,
      navigationStyle: 3
    }), {
      children: displayItems == null ? void 0 : displayItems.map((item, index) => {
        return /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.BreakpointWidthProvider, {
          sWidth: { value: 100 / sliderPerRow, unit: "%" },
          mWidth: { value: 100 / sliderPerRow, unit: "%" },
          children: /* @__PURE__ */ jsxRuntime.jsx(ui.Image, __spreadValues({
            commonStyle: {
              objectFit: props.crop ? "cover" : "contain",
              height: commonStyle == null ? void 0 : commonStyle.height,
              width: "100%"
            },
            fetchPriority: index === 0 ? "high" : "auto"
          }, item))
        }, index);
      })
    }))
  });
};
Slider.displayName = "Slider";
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  ${coreRenderer.getStyle(commonStyle)};
  overflow: hidden;
`
);

exports.Slider = Slider;
